/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  const isMobile = window.matchMedia("only screen and (max-width: 767px)").matches;

  if (!isMobile) {
    var zoomImgs = [...document.querySelectorAll('.image-zoom')];
    var panes = document.querySelectorAll('.image-details');
    var modalLinks = document.querySelectorAll('.product-single__media-link'); 
    modalLinks.forEach((link) => link.style.display = 'none');

    zoomImgs.map((img, index) => {
      new Drift(img, {
        paneContainer: panes[index],
        inlinePane: false
      });
    });
  }
})();

/*
* PDP description "Read more" (3 lines) — added 2026-09-22.
* readMore() lives in snippets/product.liquid but only ran on DOMContentLoaded,
* before the theme CSS applied, so descriptions were never truncated.
* Re-run it once styles/fonts are ready and on resize.
*/
(function() {
  if (typeof window.readMore !== 'function') return;

  function isExpanded() {
    var btn = document.querySelector('[data-read-more-btn]');
    return btn && btn.classList.contains('rm-expanded');
  }

  function run() {
    // Never re-collapse a description the customer opened
    if (!isExpanded()) window.readMore();
  }

  if (document.readyState === 'complete') {
    run();
  } else {
    window.addEventListener('load', run);
  }

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(run, 200);
  });

  // After "Read less", re-measure so the 3-line height matches the current screen size
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-read-more-btn]')) setTimeout(run, 0);
  });
})();
